import React from 'react'
import WomenBannerSection from './WomenCategorySections/WomenBannerSection'
import ShopCardSection from './WomenCategorySections/ShopCardSection'
import CategorySearchBar from './WomenCategorySections/CategorySearchBar'
import ShopByWomenCategory from './WomenCategorySections/ShopByWomenCategory'
import WomenTredingSection from './WomenCategorySections/WomenTredingSection'
import WomenFindYourStyle from './WomenCategorySections/WomenFindYourStyle'
import WomenTradingStore from './WomenCategorySections/WomenTradingStore'
import WomenFashionGroup from './WomenCategorySections/WomenFashionGroup'
import WomanFashionEnthusiasts from './WomenCategorySections/WomanFashionEnthusiasts'
import WomenLastSearchRelated from './WomenCategorySections/WomenLastSearchRelated'
import { useRouter } from 'next/router'

export default function WebCategoryMain() {
  const router = useRouter()
  return (
    <React.Fragment>
      <WomenBannerSection />
      <ShopCardSection />
      {/* <CategorySearchBar /> */}
      <ShopByWomenCategory />
      <WomenTredingSection />
      <WomenFindYourStyle />
      <WomenTradingStore />
      <WomenFashionGroup />
      <WomanFashionEnthusiasts />
      {/* <WomenLastSearchRelated /> */}
    </React.Fragment>
  )
}
